module.exports = __webpack_public_path__ + "img/onetwotree2.b4c7d93e.jpg";